import { Flex } from 'antd';
import styles from './progress-bar.module.scss';
import { calculatePercentage } from '@/utils/helpers';
import {
  Insight,
  InsightLanguageDistribution,
} from '@/services/dashboard-service/dashboard.service.types';

interface ProgressBarProps {
  data: Insight | InsightLanguageDistribution;
  sumOfData: number;
  sumForWidth: number;
}

export default function ProgressBar({ data, sumOfData, sumForWidth }: ProgressBarProps) {
  const colorClasses = ['purple1', 'purple2', 'purple3', 'red1', 'red2'];

  const getValue = (
    value: number | null | { count: number; language_flag_url: string | null }
  ): number | null => {
    if (typeof value === 'object' && value !== null && 'count' in value) {
      return value.count;
    }
    return value;
  };

  return (
    <Flex className={styles.progressBar}>
      {Object.keys(data)
        .slice(0, colorClasses.length)
        .map((key, index) => {
          const numericValue = getValue(data[key]);
          const percentageValue = calculatePercentage(numericValue, sumOfData);
          const widthPercentage = calculatePercentage(numericValue, sumForWidth);
          return (
            <div
              className={`${styles[colorClasses[index]]} ${styles.bar}`}
              style={{ width: `${widthPercentage}%` }}
              key={`bar-${key}`}
            >
              {percentageValue >= 4 ? `${percentageValue}%` : ''}
            </div>
          );
        })}
    </Flex>
  );
}
